interface InputProps {
  minThresh: number | undefined
  maxThresh: number | undefined
  val: number | undefined
}

export const THRESHOLD_TOLERANCE = 0.1 // 10%

export const calcTooltipLabel = ({ minThresh, maxThresh, val }: InputProps): string | undefined => {
  // undefined values
  if (minThresh == null || maxThresh == null || val == null) return undefined
  // Calculate the tolerance threshold range as a percentage of the threshold range
  const closeThresholdRange = (maxThresh - minThresh) * THRESHOLD_TOLERANCE
  // show min threshold
  if (val < minThresh) return `Below min threshold (${minThresh})`
  if (val === minThresh) return `Min threshold reached (${minThresh})`
  if (Math.abs(val - minThresh) <= closeThresholdRange) return `Close to min threshold (${minThresh})`
  // show max threshold
  if (val === maxThresh) return `Max threshold reached (${maxThresh})`
  if (val > maxThresh) return `Max threshold exceeded (${maxThresh})`
  if (Math.abs(val - maxThresh) <= closeThresholdRange) return `Close to max threshold (${minThresh})`
  // in range
  return undefined
}
